import { render, staticRenderFns } from "./ScanPermissionStatCard.vue?vue&type=template&id=5c852e80&"
import script from "./ScanPermissionStatCard.vue?vue&type=script&lang=ts&"
export * from "./ScanPermissionStatCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports